export const CDN_URL = import.meta.env.VITE_CDN_URL;
